/**
 * SearchBar — Reusable search input
 */
import { Search } from '@mui/icons-material';
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import React from 'react';

interface SearchBarProps extends Omit<TextFieldProps, 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  placeholder = 'Search…',
  ...rest
}) => (
  <TextField
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    size="small"
    {...rest}
    sx={{
      '& .MuiOutlinedInput-root': { borderRadius: 2.5 },
      ...rest.sx,
    }}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Search sx={{ fontSize: 18, color: 'text.disabled' }} />
        </InputAdornment>
      ),
    }}
  />
);

export default SearchBar;
